import { Injectable } from '@angular/core';
import { OverlayRef } from '@angular/cdk/overlay';

@Injectable({ providedIn: 'root' })
export class TooltipService {
  private openOverlay?: OverlayRef;

  open(overlayRef: OverlayRef) {
    if (this.openOverlay && this.openOverlay !== overlayRef) {
      this.openOverlay.detach();
    }
    this.openOverlay = overlayRef;
  }

  close(overlayRef: OverlayRef) {
    if (this.openOverlay === overlayRef) {
      this.openOverlay.detach();
      this.openOverlay = undefined;
    }
  }

  closeAll() {
    this.openOverlay?.detach();
    this.openOverlay = undefined;
  }
}
